export enum LTCDatesOptions {
  ThisYear = 1,
  ThisMonth,
  LastMonth
}